import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/lib/seo";

export default function AdminLogin() {
  useSeo({ title: "Espace confidentiel | Losta Group", description: "Accès réservé.", path: "/admin/login" });
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  const fieldCls = "w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3.5 text-sm text-white placeholder:text-slate-500 outline-none focus:border-[var(--gold)]/60";

  return (
    <div className="min-h-screen flex items-center justify-center px-5 radial-gold">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo /></div>
        <form onSubmit={submit} className="rounded-2xl border border-white/10 card-lux p-8" data-testid="admin-login-form">
          <div className="eyebrow mb-2 flex items-center gap-2"><Lock className="h-3.5 w-3.5" /> Espace confidentiel</div>
          <h1 className="font-serif text-3xl text-white mb-7">Administration</h1>
          <label className="block mb-4">
            <span className="mb-2 block text-xs uppercase tracking-wider text-slate-400">Email</span>
            <input type="email" className={fieldCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          </label>
          <label className="block mb-6">
            <span className="mb-2 block text-xs uppercase tracking-wider text-slate-400">Mot de passe</span>
            <input type="password" className={fieldCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          </label>
          {err && <p className="mb-4 text-sm text-red-400" data-testid="admin-error">{err}</p>}
          <button type="submit" disabled={loading} className="btn-gold w-full rounded-full px-6 py-3.5 text-sm uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
